import React, { useContext } from 'react';
import {useIntl} from 'react-intl';

import {Button} from '@marketplace/ui-elements';

import { ApplicationDataType } from './application.types';
import { EMApplicationStatuses, EmbedModeContext, TEMApplication, useEmbedMode } from '../../../features';
import { DeviceSvg, TypeSvg, CategorySvg} from './svg';
import {getParsedApplicationAttributes} from './helpers';

import AddedIcon from '../../../assets/svg/added.svg'

import './style.scss';


export function ApplicationDescription(props: ApplicationDataType) {
  const { formatMessage, formatDate } = useIntl();

  const { isEmbeddedMode, embedSource } = useEmbedMode();
  const { getApplicationById, changeApplication } = useContext(EmbedModeContext);

  const application: TEMApplication | null = getApplicationById && getApplicationById(props.data.id);
  const applicationStatus = application ? application.status : EMApplicationStatuses.UNINSTALLED;
  const showedAddButton = !([EMApplicationStatuses.INSTALLED, EMApplicationStatuses.UNINSTALL].includes(applicationStatus));
  const showedRemoveButton = [EMApplicationStatuses.INSTALLED, EMApplicationStatuses.UNINSTALL].includes(applicationStatus);
  const isBackendApp = props?.data?.application_launch_type?.name == 'BACKEND_SERVICE' ? true : false;

  const handleAddApplication = () => {
    const transformedData: TEMApplication | undefined = changeApplication?.transformAPIToEMData({ ...props.data, status: EMApplicationStatuses.INSTALL });
    transformedData && changeApplication && changeApplication(transformedData);
  }

  return (
    <div className="application-page__descrition">
      <div className="description-img">
        { props.data.icon && props.data.icon !== ""
          && <img src={props.data.icon} alt="" /> }
      </div>
      <div className="description-content">
        <h1 className="description-content__title">
          {props.data.name}
        </h1>
        <div className="description-content__info">
          <div className="info-types">
            <span className="info-types__by">{formatMessage({id: 'app_gallety_by'})}</span>
            {!props.partnerDetailsData.website && <span>{props.partnerDetailsData.company_name}</span>}
            {props.partnerDetailsData.website &&
            <a className="info-types__link" href={props.partnerDetailsData.website} target='_blank'>{props.partnerDetailsData.company_name}</a>}
          </div>
          <div className="info-types">
            {formatMessage({id: 'app_gallery_updated'})}:
            <span className="info-types__margin-text">
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                formatDate(props.data?.updated_at, {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                })
              }
            </span>

          </div>
          <div className="info-types">
            <DeviceSvg />
            <span className='info-types__capitalize'>{props.data.application_launch_type?.type?.toLowerCase().split('_').join(' ')}</span>
            /
            <span className='info-types__capitalize'>{props.data.application_launch_type?.name?.toLowerCase().split('_').join(' ')}</span>
          </div>
          <div className="info-types">
            <TypeSvg />
            {getParsedApplicationAttributes(props.data.categories)}
          </div>
          <div className="info-types">
            <CategorySvg />
            {getParsedApplicationAttributes(props.data.products)}
          </div>
        </div>
        <div className="description-content__text">
          {props.data.short_description}
        </div>
        <div className="description-content__button" hidden={isEmbeddedMode && embedSource == 'ehr'}>
        {!isBackendApp &&
          <Button onClick={()=> window.open(props.data.launch_url)}>
            {formatMessage({id: 'app_gallery_launch'})}
          </Button>
        }
        </div>
        <div className="description-content__button" hidden={!isEmbeddedMode && embedSource != 'ehr' && !isBackendApp}>
          {showedAddButton && isEmbeddedMode && embedSource == 'ehr' && !isBackendApp &&
          <Button onClick={handleAddApplication} rootClassName="application-list-add-app-button" loading={applicationStatus === EMApplicationStatuses.INSTALL}>
            {formatMessage({ id: 'app_gallery_add_app' })}
          </Button>
          }
          {showedRemoveButton && isEmbeddedMode && embedSource == 'ehr' && !isBackendApp &&
          <div className="added-status">
            <img src={AddedIcon} alt="" /><span>{formatMessage({id: 'app_gallery_added'})}</span>
          </div>
          }
        </div>
      </div>
    </div>
  );
}
